import { useTranslation } from 'react-i18next';

export default function TrustBar() {
  const { t } = useTranslation();

  const items = [
    {
      icon: 'ri-user-star-line',
      title: t('trustBar.item1Title'),
      desc: t('trustBar.item1Desc'),
    },
    {
      icon: 'ri-camera-line',
      title: t('trustBar.item2Title'),
      desc: t('trustBar.item2Desc'),
    },
    {
      icon: 'ri-shield-check-fill',
      title: t('trustBar.item3Title'),
      desc: t('trustBar.item3Desc'),
    },
  ];

  return (
    <section className="flex flex-col items-center justify-center bg-[#F0EDE6] px-4 py-6 sm:py-16 md:py-20 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#2B8FBF]/5"></div>
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-[#2B8FBF]/5"></div>
        <p className="absolute bottom-4 left-0 right-0 text-center text-[#D8D4CC] text-3xl sm:text-5xl md:text-8xl font-black tracking-widest select-none">
          {t('trustBar.watermark')}
        </p>
      </div>

      <div className="relative z-10 w-full max-w-2xl mx-auto">
        {/* Label */}
        <p className="text-center text-xs font-bold tracking-[0.2em] text-[#2B8FBF] uppercase mb-2 sm:mb-3">
          {t('trustBar.label')}
        </p>

        {/* Headline */}
        <h2 className="text-center text-xl sm:text-2xl md:text-4xl font-black text-gray-900 uppercase leading-tight mb-2 sm:mb-4">
          {t('trustBar.headline')}
        </h2>

        <p className="text-center text-gray-500 text-xs sm:text-sm md:text-base mb-5 sm:mb-8 md:mb-10 max-w-md mx-auto">
          {t('trustBar.subtext')}
        </p>

        {/* Card */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl p-4 sm:p-7 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            {items.map((item) => (
              <div key={item.title} className="flex items-start gap-3 sm:gap-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-[#2B8FBF]/10">
                  <i className={`${item.icon} text-[#2B8FBF] text-base sm:text-xl`}></i>
                </div>
                <div>
                  <p className="text-xs sm:text-sm font-bold text-gray-800 mb-0.5 sm:mb-1">{item.title}</p>
                  <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
